import { FeatureSet } from '../feature/featureset.model';
import { Group } from '../group/group.model';
import { DateUtil } from "../common/date";
import {each,map,isEmpty, filter} from 'underscore';


export class Role {
    public static defaultNAtranslateValue = "N/A";
    public Id: number = 0;
    public Name: string = "";
    public Description: string = "";
    public IsActive: boolean = true;
    public FeatureSetList: Array<FeatureSet> = [];
    public GroupList: Array<Group> = [];
    public Labels: string;
    public FeatureText: string;
    public CreatedOn: Date | string;
    public CreatedBy: string;
    public IsStandard: boolean;
    public IsHoneywell: boolean;
    public IsClonable: boolean;
    public FeatureSetCount: number = 0;
    public AssociatedGroupSummary: string;
    public AssociatedGroupCount: number;
    public UpdatedBy: string;
    public UpdatedOn: Date | string = "";
    public IsFeatureSetSelected: boolean = true;
    public showFeatureSet: boolean = false;
    public CEID: number = 0;

    constructor(role: Role) {
        this.Id = role.Id || 0;
        this.Name = role.Name || "";
        this.Description = role.Description || "";
        this.IsActive = role.IsActive || false;
        this.CreatedBy = role.CreatedBy;
        this.IsStandard = role.IsStandard;
        this.IsClonable = role.IsClonable || false;
        this.IsHoneywell = role.IsHoneywell || false;
        this.FeatureSetCount = role.FeatureSetCount || 0;
        this.AssociatedGroupSummary = role.AssociatedGroupSummary || Role.defaultNAtranslateValue;
        this.AssociatedGroupCount = role.AssociatedGroupCount || 0;
        this.UpdatedBy = role.UpdatedBy || "";
        this.CEID = role.CEID || 0;

        this.UpdatedOn = DateUtil.ConvertToLocalTimeZone(role.UpdatedOn);
        this.CreatedOn = DateUtil.ConvertToLocalTimeZone(role.CreatedOn);

        //FeatureSet
        if (role.FeatureSetList) {
            let fsList = map(role.FeatureSetList, (f) => { return new FeatureSet(f) });
            this.FeatureSetList = this.featureSetDependencyCheck(fsList);
        } else {
            this.FeatureSetList = [];
        }

        if (role.GroupList && role.GroupList.length > 0) {
            this.GroupList = map(role.GroupList, (item: Group) => { return new Group(item) });
        }
    }

    getAssociatedFeatureSet(): Array<FeatureSet> {

        let featureList: Array<FeatureSet> = [];

        if (this.FeatureSetList.length > 0) {
            featureList = filter(this.FeatureSetList, (item) => { return item.IsAssocaitedWithRole == true });
        }
        return featureList;
    }

    validateFeatureSet(): boolean {
        this.IsFeatureSetSelected = this.getAssociatedFeatureSet().length > 0;
        return this.IsFeatureSetSelected;
    }

    validate(): boolean {
        if (this.Name) this.Name = this.Name.trim();
        if (this.Description) this.Description = this.Description.trim();

        return !(isEmpty(this.Name) || isEmpty(this.Description) || !this.validateFeatureSet())
    }

    getClonedRole(): Role {
        this.Id = 0;
        this.IsStandard = false;
        return this;
    }

    private featureSetDependencyCheck(featureSetList: Array<FeatureSet>): Array<FeatureSet> {
        each(featureSetList, (fs: FeatureSet) => {
            fs.toggleForDependentFeatureSet(featureSetList);
        });

        return featureSetList;
    }
}
